module.exports = __webpack_public_path__ + "prod/1.42.2/img/wdzx.de89466f.png";